import { Controller } from "@hotwired/stimulus"

// Scroll reveals — rise 16px + fade, staggered by data-reveal-delay
// (CLAUDE_DESIGN §6). Reduced-motion → everything visible instantly.
export default class extends Controller {
  connect() {
    this.reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    this.els = Array.from(this.element.querySelectorAll("[data-reveal]"))

    if (this.reduced || !("IntersectionObserver" in window)) {
      this.els.forEach((e) => e.classList.add("is-in"))
      return
    }

    this.io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return
          const el = entry.target
          const delay = parseInt(el.dataset.revealDelay || "0", 10)
          setTimeout(() => el.classList.add("is-in"), delay)
          this.io.unobserve(el)
        })
      },
      { rootMargin: "0px 0px -8% 0px", threshold: 0.01 }
    )
    this.els.forEach((e) => this.io.observe(e))

    // Safety net: never leave content hidden if scroll never fires.
    this.fallback = setTimeout(() => this.els.forEach((e) => e.classList.add("is-in")), 2600)
  }

  disconnect() {
    if (this.io) this.io.disconnect()
    clearTimeout(this.fallback)
  }
}
